if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.excludedIds = this.dataset.excludeProducts.split(',');
    }

    connectedCallback() {
      if (!this.productId) return;

      fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${this.productId}`)
        .then(response => response.json())
        .then(({ products }) => {
          if (products.length < 0) return;


          const nodeString = [...products.filter(x => !this.excludedIds.find((y) => y === x.id))
            .map((product) => `<quick-buy data-product-handle="${product.handle}"></quick-buy>`)];

          // insert product tiles into component, then unwrap the children into the slider
          nodeString.map((string) => {
            const div = document.createElement('div');
            div.classList.add('swiper-slide');
            div.innerHTML = string;
            this.parentElement?.insertBefore(div, this);
          })
        }).then(() =>{
          // shuffle the slider for variety
          const swiperWrapper = this.closest('.swiper-wrapper');
          if (!swiperWrapper) return;

          const allNodes = [...swiperWrapper.childNodes];
          const shuffledNodes = shuffle(allNodes);
          swiperWrapper.replaceChildren(...shuffledNodes);
        }).then(() => {
          this.closest('swiper-carousel')?.swiper?.update();
        }).finally(() => {
          this.remove();
        });
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}